import * as React from "react";
import { CommonProjectInsightsHelp } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonInsightViews";
import { CommonInsightsDeploymentFailureRateOverview, CommonInsightsDeploymentFailureRateTopics } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonInsightsDeploymentFailureRateViews";
import type { CategorizedPageHelpRegistration } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registry/pageHelpRegistry";
import pageIds from "~/pageIds";
export const ProjectInsightsDeploymentFailureRateRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.project().insights.failureRate,
    renderOverview: (props) => (<>
            <CommonInsightsDeploymentFailureRateOverview /> <CommonProjectInsightsHelp />
        </>),
    renderTopics: (props) => <CommonInsightsDeploymentFailureRateTopics />,
};
